import React, { useState  } from 'react';
import { Button, Form, Header, Container, Label, Message} from 'semantic-ui-react';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks'
import { useForm } from '../util/hooks';
import Emoji from './Emoji';
import { FETCH_POSTS_QUERY } from '../util/graphql';

function PostForm({postPicture}) {
  const { values, onChange, onSubmit } = useForm(createPostCallback, {
    body: '',
    postPicture: postPicture.postPicture
  });

  const [createPost, { loading, error, data}] = useMutation(CREATE_POST_MUTATION, {
    variables: values,
    update(proxy, result) {
      const data = proxy.readQuery({
        query: FETCH_POSTS_QUERY
      });
      console.log("In PostForm.js", values.postPicture)
      data.getPosts = [result.data.createPost, ...data.getPosts];
      proxy.writeQuery({ query: FETCH_POSTS_QUERY, data });
      values.body = '';
      values.postPicture= '';

    }
  });

  const initialState = {
    body: "",
    postPicture: ""
  };

  const [{}, setState ] = useState(initialState);

  const clearForm = () => {
    setState({ ...initialState });
  }
  function createPostCallback() {
    createPost();
  }

  return (
    <>
    
    <Container>
      <Form onSubmit={onSubmit} style={{ marginBottom: 20 }}>
        <Form.Field >
        <Label as='h1'> Some descriptions go here.<Emoji symbol="😸" /></Label>
          <Form.Input 
            placeholder="Hello! Enter your post!"
            name="body"
            required={true}
            onChange={onChange}
            value={values.body}
            error={error ? true : false}
          />
          <Container className={{display:"none"}}>
          <Label as='h1'>The URL for picture will appear here. If you'd like, you can change it with another image URL<Emoji symbol="🙃" /></Label>
          <Form.Input 
            placeholder="Hello! Enter your URL for picture"
            name="postPicture"
            onChange={onChange}
            value={values.postPicture}
            error={error ? true : false}  
          />
          </Container>
          {/* TODO: Move this Header Up in the state */}
          <Header textAlign="center" as='h1'> Third, There is No Third Step. Submit Your Post! <Emoji symbol="❣️" /></Header>
          <Label as='h1'> Before you submit, please make sure that your post abides by our community guidelines<Emoji symbol="🙏" /></Label>          
          <Button type="submit" color="teal" fluid>
            Submit
          </Button>
          <Button onClick={clearForm} type="input" color="red" fluid>
            Reset
          </Button>
        </Form.Field>
      </Form>
      {error && (
        <div className="ui error message" style={{ marginBottom: 20 }}>
          <ul className="list">
            <li>{error.graphQLErrors[0].message}</li>
          </ul>
        </div>
      )}
      {data && (
      <Message
      success
      header='Form Completed'
      content="You've successfully submitted your post 😛 😜"
      />
      )}
      {loading && (
      <Message
      loading
      header='Submission in progress...'
      content="Form is taking longer than expected 😥 😣"
      />
      )}
      </Container>
      </>
  );
}

const CREATE_POST_MUTATION = gql`
  mutation createPost($body: String!, $postPicture: String!) {
    createPost(body: $body, postPicture: $postPicture ) {
      id
      body
      createdAt
      username
      avatar
      postPicture
      likes {
        id
        username
        createdAt
      }
      likeCount
      dislikes {
        id
        username
        createdAt
      }
      dislikeCount
      comments {
        id
        body
        username
        createdAt
      }
      commentCount
    }
  }
`;

export default PostForm;
